import { Col, Row } from 'reactstrap';
import domainModel from 'domain-model';
import type { Cart } from 'domain-model/types/pcs';
import React from 'react';
import _ from 'lodash';
import Money from '../Money';

function MultiCartSummary({
  carts,
}: {
  carts: { [key: string]: Cart };
}): JSX.Element {
  const cartsWithRows = _.filter(carts, cart => cart.cartRows.length > 0);
  const cartsGroupedByCurrency = _.groupBy(
    cartsWithRows,
    cart => cart.currency,
  );

  const multiCartSummary = _.map(
    cartsGroupedByCurrency,
    (cartGroup, currency) => (
      <>
        {_.sumBy(
          cartGroup.map(x => domainModel.cart.getCartRecycleAmount(x)),
        ) !== 0 && (
          <>
            <Row className="justify-content-between">
              <Col>
                <h5 className="mb-0 fw-light">
                  Pant <span className="fw-light">(exkl. moms)</span>
                </h5>
              </Col>
            </Row>
            <Row className="justify-content-between">
              <Col>
                <h5 className="mb-0 fw-light">
                  <Money
                    currency={currency}
                    value={_.sumBy(
                      cartGroup.map(x =>
                        domainModel.cart.getCartRecycleAmount(x),
                      ),
                    )}
                  ></Money>
                </h5>
              </Col>
            </Row>
          </>
        )}
        <Row className="justify-content-between">
          <Col>
            <h5 className="mb-0">
              Totalt <span className="fw-light">(exkl. moms)</span>
            </h5>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col>
            <h5 className="mb-0">
              <Money
                currency={currency}
                value={_.sumBy(
                  cartGroup.map(
                    x =>
                      domainModel.cart.getCartTotal(x) +
                      domainModel.cart.getCartRecycleAmount(x),
                  ),
                )}
              ></Money>
            </h5>
          </Col>
        </Row>
      </>
    ),
  );
  return (
    <div key={'multiCardSummary'}>
      {multiCartSummary.map((summary, index) => (
        <div key={index}>{summary}</div>
      ))}
    </div>
  );
}

export default MultiCartSummary;
